"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ErrorBoundary = void 0;
var _mui = require("@ori-ui/mui");
var _logger = require("@ori/logger");
var _react = require("react");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ErrorBoundary = (param)=>{
    let { debug, modulePosition, children, module } = param;
    const localLogger = (0, _logger.useLogger)('ErrorBoundary', {
        module,
        modulePosition
    });
    const fallback = (0, _react.useCallback)((param)=>{
        let { error } = param;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_mui.Alert, {
            severity: "error",
            sx: _styles.alertStyle,
            variant: "outlined",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.AlertTitle, {
                    sx: _styles.alertTitleStyle,
                    children: "Error"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                    children: "Module:"
                }),
                " ",
                module !== null && module !== void 0 ? module : 'Unknown',
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                    children: "Position:"
                }),
                " ",
                modulePosition + 1,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                    children: "Reason:"
                }),
                " ",
                error === null || error === void 0 ? void 0 : error.message
            ]
        });
    }, [
        module,
        modulePosition
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
        fallback: debug ? fallback : null,
        logger: localLogger,
        children: children
    });
};
exports.ErrorBoundary = ErrorBoundary;
